import DottedMap from 'dotted-map';

function DotsMapMap(props) {
  const map = new DottedMap({ height: 50, grid: 'diagonal' });

  const svgMap = map.getSVG({
    radius: 0.35,
    color: '#99CAED',
    shape: 'circle',
    backgroundColor: 'none',
  });

  return (
    <>
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" className='map-dots'>
          {props.dots.map(function (dot) {
            var xOffset = 0;
            var yOffset = -200;

            if(props.mapWidth - dot.x < 400) {
              xOffset = -400;
            }

            if(dot.y < 200) {
              yOffset = 0;
            }

            return ([
              <circle id="map-dot" cx={dot.x} cy={dot.y} r="5" key={dot} fill="#ED9C00" />,
              <g id="g">
                <rect x={xOffset+dot.x} y={yOffset+dot.y} stroke="#007bd3" strokeWidth="3" fill="white" width="400" height="200" rx="10" ry="10" />
                <foreignObject x={xOffset+dot.x} y={yOffset+dot.y} width="400" height="200" style={{fontSize: "12px", fontFamily: 'Fira Sans', padding: "10px 10px"}}>
                  <div xmlns="http://www.w3.org/1999/xhtml">
                    <p><b>{dot.Year} |</b> {dot.Location}</p>
                    <p>{dot.Description}</p>
                    {dot.Reference === null ? <p/> :
                      <p><a href={dot.Reference}><b>Read more</b></a></p>
                    }
                  </div>
                </foreignObject>
              </g>,
            ]);
          })}
        </svg>
        <use xlinkHref="#g"/>
        <img
          src={`data:image/svg+xml;utf8,${encodeURIComponent(svgMap)}`}
          alt='World map'
        />
      </div>
    </>
  );
}

export default DotsMapMap;
